import { render, staticRenderFns } from "./training-quize-wap.vue?vue&type=template&id=62e396ed"
import script from "./training-quize-wap.vue?vue&type=script&lang=js"
export * from "./training-quize-wap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports